// extracted by mini-css-extract-plugin
export var buttons = "W_cn";
export var column = "W_b8";
export var columns = "W_b7";
export var container = "W_b";
export var down = "W_dx";
export var download = "W_dw";
export var footer = "W_cC";
export var information = "W_dv";
export var section = "W_j";
export var show = "W_L";
export var text = "W_ck";
export var title = "W_g";
export var units = "W_dy";
export var up = "W_dB";
export var upload = "W_dz";
export var waveOne = "W_q";
export var waveThree = "W_cr";
export var waveTwo = "W_n";
export var waves = "W_cq";